import { motion } from "framer-motion";
import { AlertTriangle, Clock, FolderX, EyeOff, UserX } from "lucide-react";

const problems = [
  { icon: Clock, text: "Leads are not followed up instantly" },
  { icon: FolderX, text: "No structured CRM or pipeline" },
  { icon: EyeOff, text: "No visibility into what converts" },
  { icon: UserX, text: "Missed opportunities after initial contact" },
];

export const ProblemSection = () => {
  return (
    <section className="py-20 px-4 bg-background">
      <div className="max-w-4xl mx-auto">
        <motion.div
          className="text-center mb-12"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
        >
          <div className="inline-flex items-center gap-2 bg-destructive/10 text-destructive px-4 py-2 rounded-full mb-6">
            <AlertTriangle className="w-4 h-4" />
            <span className="text-sm font-medium">The Problem</span>
          </div>
          <h2 className="text-3xl md:text-4xl font-bold text-foreground mb-6">
            You're Losing Leads Right Now
          </h2>
          <p className="text-muted-foreground text-lg max-w-2xl mx-auto">
            Most agencies stop at generating leads. But businesses lose 30–50% of potential customers due to slow follow-ups, poor systems, and lack of visibility.
          </p>
        </motion.div>

        <div className="grid sm:grid-cols-2 gap-4 mb-10">
          {problems.map((problem, i) => (
            <motion.div
              key={i}
              className="flex items-start gap-4 p-5 rounded-xl border border-border bg-card"
              initial={{ opacity: 0, y: 15 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: i * 0.1 }}
            >
              <div className="w-10 h-10 rounded-lg bg-destructive/10 flex items-center justify-center flex-shrink-0">
                <problem.icon className="w-5 h-5 text-destructive" />
              </div>
              <p className="text-foreground font-medium">{problem.text}</p>
            </motion.div>
          ))}
        </div>

        <motion.div
          className="text-center p-6 rounded-xl bg-muted border border-border"
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
        >
          <p className="text-lg font-semibold text-foreground">
            Most businesses lose <span className="text-destructive">30–50% of leads</span> after they come in.
          </p>
        </motion.div>
      </div>
    </section>
  );
};
